<template>
  <!-- wms邀请码列表 -->
  <div class="content">
    <div class="login-out"
         @click="logOut">
      退出登录
    </div>

    <!-- 列表 -->
    <div v-if="loading&&codeList.length"
         class="list-content">
      <div class="list-items"
           v-for="item in codeList"
           :key="item.id">
        <div class="list-item-lf">
          <div class="title">{{item.code}}</div>
          <div>
            <label class="label">可抵扣金额：</label>
            <label class="value">¥{{item.price}}</label>
          </div>
          <div>
            <label class="label">有效时间至：</label>
            <label class="value">{{item.validTime}}</label>
          </div>
        </div>
        <button class="list-item-btn"
                v-clipboard:copy="item.code"
                v-clipboard:success="onCopy"
                v-clipboard:error="onError">复制邀请码</button>
      </div>
    </div>

    <!-- 空状态 -->
    <div class="empty-box"
         v-else-if="loading&&!codeList.length">
      <img :src="emptyBg"
           alt="" />
      <div class="title">暂无可用邀请码</div>
      <div class="desc">如需生成邀请码，请点击下方按钮</div>
    </div>

    <!-- 生成邀请码 -->
    <div class="submit-box">
      <button @click="getInviteCode">生成邀请码</button>
    </div>

    <!-- 弹框 -->
    <div class="dialog-modal"
         v-if="showDialog"
         catchtouchmove="catchTouchMove">
      <div class="dialog-wrapper"
           catchtouchmove="catchTouchMove">
        <div class="dialog-title-box">
          <div>生成邀请码</div>
          <van-icon name="cross"
                    size="20"
                    color="#C5C5C5"
                    @click="getInviteCode" />
        </div>
        <!-- 输入邀请码 -->
        <div class="input-box"
             v-if="showInviteCode">
          <div class="label">抵扣金额（人名币元）</div>
          <input class="input"
                 :style="{borderColor:errPrice&&!inputPrice?'#FF5C5C':'#979797'}"
                 type="digit"
                 v-model="inputPrice"
                 placeholder="请填写">
          <div class="desc-box"
               v-if="errPrice&&!inputPrice">
            <van-icon name="info-o"
                      style="margin-right:6px;" />
            <div>请填写抵扣金额</div>
          </div>
          <div class="dialog-btn"
               @click="postInviteCode"
               style=" margin-top: 37px;">确定</div>
        </div>
        <!-- 复制邀请码 -->
        <div class="input-box"
             v-else>
          <div class="code">{{codeInfo.code}}</div>
          <div style="margin-bottom:8px">
            <label class="cell-label">可抵扣金额：</label>
            <label class="cell-value">¥{{codeInfo.price}}</label>
          </div>
          <div>
            <label class="cell-label">有效时间至：</label>
            <label class="cell-value">{{codeInfo.validTime}}</label>
          </div>
          <div class="dialog-btn"
               v-clipboard:copy="codeInfo.code"
               v-clipboard:success="onCopy"
               v-clipboard:error="onError"
               style=" margin-top: 28px;">复制邀请码</div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Vue from 'vue'
import { Toast } from 'vant';
import { mapGetters } from "vuex"
import VueClipboard from 'vue-clipboard2'//复制
import { apiInviteCodeList, apiGetInviteCode } from '@/api/wmsGuide'

Vue.use(VueClipboard)
Vue.use(Toast);
export default {
  data () {
    return {
      userId: 0,//导购ID
      loading: false,
      showDialog: false,//是否显示弹框
      showInviteCode: true,//是否展示输入框
      emptyBg: require('../../../public/images/empty-bg.png'),
      codeList: [],//邀请码列表
      inputPrice: '',//输入框值
      errPrice: false,//错误展示
      codeInfo: {
        code: '',
        price: 0,
        validTime: ''
      },

      pageInfo: {
        page: 1,
        pageSize: 25,
        total: 25
      },

      winHei: screen.availHeight, //屏幕高度
      style: {
        height: 0
      },
    }
  },

  computed: {
    ...mapGetters(["wmsUserId"])
  },

  mounted () {
    window.addEventListener("scroll", this.handleScroll, true);
    this.userId = this.wmsUserId
    this.getInviteCodeList()
  },

  beforeDestroy () {
    window.removeEventListener('scroll', this.handleScroll)
  },

  methods: {
    handleScroll () {
      var scrollTop = document.documentElement.scrollTop || document.body.scrollTop;
      //变量windowHeight是可视区的高度
      var windowHeight = document.documentElement.clientHeight || document.body.clientHeight;
      //变量scrollHeight是滚动条的总高度
      var scrollHeight = document.documentElement.scrollHeight || document.body.scrollHeight;
      if (scrollTop + windowHeight >= scrollHeight - 1) {
        if (this.pageInfo.page * this.pageInfo.pageSize < this.pageInfo.total) {
          this.pageInfo.page = this.pageInfo.page + 1
          this.getInviteCodeList()
        }
      }
    },


    // 分页获取邀请码列表
    getInviteCodeList () {
      this.$toast.loading({
        duration: 0,
        message: '加载中...',
        forbidClick: true,
      });
      let data = {
        status: 0,//	状态：0-未使用 1-已使用 2-已失效
        salesUserId: this.userId,
        page: this.pageInfo.page,
        pageSize: this.pageInfo.pageSize
      }
      apiInviteCodeList(data).then((res) => {
        this.$toast.clear();
        if (res.code === 200) {
          this.pageInfo.total = res.data.total
          let arr = res.data.records.map(item => {
            item.price = (item.price / 100).toFixed(2)
            return item
          }) || []
          this.codeList = this.codeList.concat(arr)
        } else {
          this.$toast(res.msg)
        }
        this.loading = true
      }).catch(() => {
        this.$toast('网络错误！')
      })
    },

    // 生成邀请码按钮点击事件
    getInviteCode () {
      this.inputPrice = ''
      this.showInviteCode = true
      this.showDialog = !this.showDialog
    },

    // 生成邀请码
    postInviteCode () {
      if (!this.inputPrice) {
        this.errPrice = true
        return
      }
      this.errPrice = false
      let data = {
        type: 2,//	类型：1-订单总额抵扣 2-固定金额抵扣
        salesUserId: this.userId,
        price: this.inputPrice * 100,
        buId: 102,
      }
      apiGetInviteCode(data).then((res) => {
        if (res.code === 200) {
          res.data.price = (res.data.price / 100).toFixed(2)
          this.codeInfo = res.data
          this.showInviteCode = false
          this.codeList = []
          this.getInviteCodeList()
        } else {
          this.showInviteCode = true
          this.$toast(res.msg)
        }
      }).catch(() => {
        this.$toast('网络错误！')
      })
    },

    // 复制成功时的回调函数
    onCopy (e) {
      this.showDialog = false
      Toast('内容已复制到剪切板！');
    },

    // 复制失败时的回调函数
    onError (e) {
      Toast('抱歉，复制失败！');
    },


    // 退出登录
    logOut () {
      this.$store.commit("set_wmsUserId", 0)
      window.localStorage.clear()
      this.$router.push({
        path: '/wmsLogin'
      });
    },
  }
}
</script>
<style lang="scss" scoped>
@import "./style.scss";

.content {
  // height: 100vh;
  overflow: hidden;
  background: #f7f7f7;
  font-weight: normal;
  font-family: PingFangSC-Regular, PingFang SC;
  -webkit-overflow-scrolling: touch;
  overflow: scroll;
  min-height: 100vh;
}
.login-out {
  position: fixed;
  top: 0;
  right: 0;
  left: 0;
  font-size: 14px;
  font-weight: 500;
  color: #3472fd;
  height: 50px;
  line-height: 50px;
  background: #ffffff;
  text-align: right;
  padding-right: 16px;
  border-bottom: solid 1px #e7e7e7;
  z-index: 99;
}
.empty-box {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background: #fff;
  height: 100vh;
  overflow: hidden;

  img {
    width: 218px;
    height: 230px;
  }
  .title {
    margin: 50px auto 16px;
    font-size: 26px;
    font-weight: 500;
    color: #333333;
    line-height: 26px;
  }
  .desc {
    font-size: 16px;
    color: #666666;
    line-height: 16px;
  }
}

/* 底部固定定位提交按钮*/
.submit-box {
  position: fixed;
  bottom: 0;
  left: 0;
  display: block;
  width: 100vw;
  height: auto;
  padding: 12px 16px;
  background: #fff;
  box-shadow: 0px -1px 4px 0px rgba(0, 0, 0, 0.1);
  z-index: 99;
  box-sizing: border-box;

  button {
    width: 100%;
    height: 50px;
    background: #3472fd;
    font-size: 16px;
    color: #ffffff;
  }

  button[disabled] {
    background-color: #aec7ff;
    color: #fff;
  }
}
.list-content {
  margin-top: 50px;
  padding-bottom: 84px;
  background: #f7f7f7;
  border: solid 1px #f7f7f7;

  .list-items {
    margin-top: 10px;
    padding: 16px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    background: #ffffff;
    .title {
      margin-bottom: 12px;
      font-size: 20px;
      font-weight: 500;
      color: #333333;
      line-height: 24px;
    }
    .label {
      font-size: 12px;
      color: #999999;
      line-height: 16px;
    }
    .value {
      font-size: 12px;
      color: #333333;
      line-height: 16px;
    }
    .list-item-btn {
      width: 94px;
      height: 32px;
      border-radius: 3px;
      border: 1px solid #979797;
      font-size: 14px;
      font-weight: 500;
      color: #333333;
      line-height: 32px;
      text-align: center;
    }
  }
}

.dialog-modal {
  width: 100%;
  height: 100%;
  position: fixed;
  top: 0;
  left: 0;
  background: rgba(0, 0, 0, 0.7);
  z-index: 100;
  overflow: hidden;
}

.dialog-wrapper {
  position: absolute;
  z-index: 110;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  width: 295px;
  height: 299px;
  padding: 20px;
  background: rgba(255, 255, 255, 1);
  box-sizing: border-box;
  border-radius: 6px;
}

.dialog-title-box {
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 18px;
  font-weight: 500;
  color: #000000;
  line-height: 25px;
}
.input-box {
  .label {
    margin-top: 40px;
    margin-bottom: 8px;
    font-size: 14px;
    color: #333333;
    line-height: 20px;
  }
  .input {
    margin-bottom: 4px;
    width: 100%;
    padding: 12px 16px;
    border-radius: 4px;
    border: 1px solid #979797;
    box-sizing: border-box;
    font-size: 20px;
    font-weight: normal;
  }
  .desc-box {
    display: flex;
    align-items: center;
    font-size: 12px;
    color: #ff5c5c;
    line-height: 17px;
  }
}
.dialog-btn {
  height: 57px;
  background: #3472fd;
  border-radius: 2px;
  font-size: 18px;
  font-weight: 600;
  color: #ffffff;
  line-height: 57px;
  text-align: center;
}
.code {
  margin-bottom: 20px;
  padding: 27px 0 20px;
  font-size: 24px;
  font-weight: 500;
  color: #000000;
  line-height: 34px;
  border-bottom: solid 1px #e7e7e7;
}
.cell-label {
  font-size: 14px;
  color: #666666;
  line-height: 20px;
}
.cell-value {
  font-size: 14px;
  color: #333333;
  line-height: 20px;
}
</style>